import React from "react";
import { MetadataState } from "../store";
import { useSnapshot } from "valtio";

export const XylectButton = () => {
  const MetaSnap = useSnapshot(MetadataState);

  return (
    <a href="https://xylect.com" target="_blank">
      <div className="xylectBtnContainer">
        <h6 className="xylectBtnHeader">Xylect</h6>
        <p className="xylectBtnText">
          {MetaSnap.texts?.general?.xylect || "Pump Selection Tool"}
        </p>
      </div>
    </a>
  );
};
